<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Ticket List</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
            <link-button
            :to="{name: 'newTicket'}"
            :classes="['btn-success', 'd-block', 'ml-lg-3', 'm-l-15']"
          >
            <i class="fa fa-plus-circle" />
            Create ticket
          </link-button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row justify-content-md-end">
          <div class="col-md-3 col-sm-6">
            <input-text
              type="text"
              name="keword"
              :value="search.keyword"
              placeholder="Title"
              @input="value => { setSearchField({ key: 'keyword', value }) }"
            />
          </div>
          <div class="col-md-3 col-sm-6">
            <input-select
              name="status"
              :value="search.status"
              placeholder="Status"
              class-name="custom-select"
              :options="statusOptions"
              @input="value => { setSearchField({ key: 'status', value }) }"
            />
          </div>
          <div class="col-md-3 col-sm-6">
            <input-select
              name="topic"
              :value="search.topic"
              placeholder="Topic"
              class-name="custom-select"
              :options="topicOptions"
              @input="value => { setSearchField({ key: 'topic', value }) }"
            />
          </div>
          <div class="col-md-2 col-sm-6">
            <label class="py-2">
              <input
                name="isAssigned"
                type="checkbox"
                :value="search.isAssigned"
                :true-value="true"
                :false-value="false"
                :checked="search.isAssigned"
                @change="setSearchField({ key: 'isAssigned', value:$event.target.checked })"
              >
              Assigned
            </label>
          </div>
          <div class="col-md-1 col-sm-6">
            <div class="form-group">
              <form-button
                :click="() => gotoSearch(search)"
                type="primary"
                :disabled="loading"
                class="form-control"
              >
                <i class="fa fa-search text-white" />
              </form-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-container :loading="loading">
      <div v-if="!list || list.length == 0" class="text-center">
        No Ticket found!
      </div>
      <div v-else class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped dataTable no-footer">
                  <thead>
                  <tr>
                    <th>Ticket ID</th>
                    <th>Topic</th>
                    <th>Title</th>
                    <th>Date</th>
                    <th v-if="!(currentRole == 'seller')">Seller</th>
                    <th>Status</th>
                    <th v-if="currentRole == 'supporter' || currentRole == 'admin'" class="nowrap">Assignment</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="(ticket, index) in list"
                    :class="index % 2 == 0 ? 'odd' : 'even'"
                    :key="ticket.id"
                  >
                    <td class="nowrap">
                      <uuid
                        :id="ticket.id.toString()"
                        routerKey="ticketId"
                        routerName="ticketDetail"
                        :isShortened="false">
                      </uuid>
                      <div class="notify middle-notify"
                        v-if="showNotification({ ticket, currentRole })"
                      >
                        <span class="heartbit">
                        </span>
                        <span class="point">
                        </span>
                      </div>
                    </td>
                    <td>
                      <topic-label :label="ticket.topic"></topic-label></td>
                    <td>
                      <router-link :to="{ name: 'ticketDetail', params: { ticketId: ticket.id } }">
                        <i
                          v-if="ticket.priority && (currentRole == 'supporter' || currentRole == 'admin')"
                          class="fa fa-exclamation-triangle text-danger"
                        ></i>
                        {{ ticket.title}}
                      </router-link>
                      </td>
                    <td class="nowrap"><span class="text-muted">{{ ticket.createdAt | dateDisplay }}</span> </td>
                    <td v-if="!(currentRole == 'seller')">
                      <user-avatar
                        v-if="ticket.seller"
                        :email="`${ticket.seller.email} [${ticket.userId}]`"
                        :image="ticket.seller.profileImg"
                      />
                    </td>
                    <td>
                      <ticket-status :status="ticket.status"></ticket-status>
                    </td>
                    <td v-if="currentRole == 'supporter' || currentRole == 'admin'">
                       <div class="d-flex justify-content-between align-items-center">
                        <link-button
                          v-if="currentRole == 'supporter'"
                          class="btn btn-secondary btn-xs nowrap"
                          :click="() => openConfirmAssignMe({ticketId: ticket.id, assignUserId: currentUser.id})"
                        >
                          <i class="ti-comments-smiley"></i>
                        </link-button>
                        <link-button
                          class="btn btn-secondary btn-xs nowrap"
                          v-if="currentRole == 'admin'"
                          :click="() => openAssignModal(ticket.id)"
                        >
                          <i class="ti-user"></i>
                        </link-button>
                        <user-avatar
                          v-if="ticket.supporter"
                          :name="ticket.supporter.name"
                          :image="ticket.supporter.profileImg"
                        />
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
          <pagination
            :route-name="routeName"
            :query="search"
            :current="page"
            :total="total"
          />
        </div>
      </div>
    </loading-container>
    <modal
        :show="form.showAssign"
        title="Sellect one person incharge!"
        :close="() => setField({ key: 'showAssign', value: false })"
      >
        <loading-container :loading="form.loadingModal">
          <div class="row">
            <div class="col-12">
              <input-select
                label="Person Incharge"
                :value="form.userId"
                placeholder="Choose User"
                :options="userOptions"
                @input="value => { setField({ key: 'assignUserId', value }) }"
              />
            </div>
          </div>
        </loading-container>
        <div slot="footer">
          <div slot="footer">
            <div class="flex-group">
              <link-button
                class="btn btn-danger mr-2"
                :click="() => assignTicket()"
              >
                <span v-if="update_loading">
                  <i class="fa fa-spin fa-spinner" />
                </span>
                <span v-else>
                  Assign
                </span>
              </link-button>

              <button type="button" class="btn btn-secondary flex-item" @click="() => setField({ key: 'showAssign', value: false })">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </modal>
      <!-- Delete -->
      <modal
        :show="form.showAssignConfirm"
        title="Warning"
        :close="() => setField({ key: 'showAssignConfirm', value: false })"
      >
        <h2 class="swal2-title" style="display: flex;">Are you sure to assign?</h2>

          <div slot="footer">
            <div class="flex-group">
              <link-button
                class="btn btn-danger mr-2"
                :click="() => assignTicket()"
              >
                <span v-if="update_loading">
                  <i class="fa fa-spin fa-spinner" />
                </span>
                <span v-else>
                  Assign
                </span>
              </link-button>
              <button type="button" class="btn btn-secondary flex-item" @click="() => setField({ key: 'showAssignConfirm', value: false })">
                Cancel
              </button>
            </div>
          </div>
        </modal>
  </div>
</template>


<script>
  import { mapGetters, mapActions } from "vuex";

  import LoadingContainer from "@/components/Misc/LoadingContainer";
  import InputSelect from "@/components/Form/InputSelect";
  import InputText from "@/components/Form/InputText";
  import Pagination from "@/components/Misc/Pagination";
  import Modal from "@/components/Misc/Modal";
  import LinkButton from "@/components/Misc/LinkButton";
  import FormButton from "@/components/Form/FormButton";
  import Breadcrumb from "@/components/Common/Breadcrumb";
  import TicketStatus from '@/components/Common/TicketStatus';
  import TopicLabel from '@/components/Common/TopicLabel'
  import UserAvatar from '@/components/Common/UserAvatar'
  import Uuid from "@/components/Common/Uuid";

  export default {
    name: "TicketList",
    components: {
      LoadingContainer,
      InputSelect,
      Pagination,
      Modal,
      LinkButton,
      InputText,
      FormButton,
      Breadcrumb,
      TicketStatus,
      TopicLabel,
      UserAvatar,
      Uuid
    },
    // filters: {
    //   showNotification: function({ ticket, currentRole }) {
    //     console.log ({ticket, currentRole })
    //     return (ticket.sellerRead == false && currentRole == 'seller') || (ticket.supporterRead == false && (currentRole == 'supporter' || currentRole == 'admin'))
    //   }
    // },
    beforeMount() {
      const query = this.$route.query;
      const page = query.page ? parseInt(query.page) : 1;
      const status = query.status;
      const topic = query.topic;
      const isAssigned = query.isAssigned;
      const keyword = query.keyword;

      this.getTickets({ page, search: { status, topic, isAssigned, keyword } });
    },
    computed: {
      ...mapGetters({
        user: "auth/user",
        list: "ticket/list",
        search: "ticket/search",
        loading: "ticket/loading",
        userList: "user/list",
        count: "ticket/count",
        total: "ticket/total",
        page: "ticket/page",
        form: "ticket/form",
        error: "ticket/error",
        update_loading: "ticket/update_loading"
      }),
      userOptions() {
        const users = this.userList
          .map(o => {
            return {
              value: o.id,
              text: o.name
            };
          });

        return users;
      },
      statusOptions() {
        return [
          { value: "created", text: "Created" },
          { value: "processing", text: "Processing" },
          { value: "closed", text: "Closed" }
        ];
      },
      topicOptions() {
        return [
          { value: "Cancel", text: "Cancel" },
          { value: "Pre-shipment", text: "Pre-shipment" },
          { value: "Refund", text: "Refund" },
          { value: "Replacement", text: "Replacement" },
          { value: "Deposit", text: "Deposit" },
          { value: "Verify Address", text: "Verify Address" },
          { value: "Other", text: "Other" }
        ];
      },
      assignedOptions() {
        return [
          { value: true, text: "Assigned" },
          { value: false, text: "UnAssigned" }
        ];
      },
      routeName() {
        return this.$router.name;
      },
      currentPage() {
        return this.$store.state.route.meta.title;
      },
      currentUser() {
        return this.user || {};
      },
      currentRole() {
        return this.currentUser.role;
      }
    },
    methods: {
      ...mapActions({
        getTicket: "ticket/getTicket",
        getTickets: "ticket/getTickets",
        setSearchField: "ticket/setSearchField",
        setField: "ticket/setField",
        openAssignModal: "ticket/openAssignModal",
        openConfirmAssignMe: "ticket/openConfirmAssignMe",
        assignTicket: "ticket/assignTicket"
      }),
      gotoSearch(query) {
        this.$router.push({ name: this.routeName, query });
      },
      showNotification: function({ ticket, currentRole }) {
        return (ticket.sellerRead == false && currentRole == 'seller') || (ticket.supporterRead == false && (currentRole == 'supporter' || currentRole == 'admin'))
      }
    }
  };
</script>
<style>
.middle-notify{
  top: -10px !important;
}
</style>
